import React from "react";

export default function SettingsField({
  label,
  htmlFor,
  description,
  children,
  required = false,
}) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 items-start">
      <label
        htmlFor={htmlFor}
        className="text-sm font-medium text-text-secondary sm:pt-2"
      >
        {label} {required && <span className="text-text-destructive">*</span>}
      </label>
      <div className="sm:col-span-2 space-y-2">
        {children}
        {description && (
          <p className="text-xs text-text-muted leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}
